import { render, staticRenderFns } from "./InputProductDetails.vue?vue&type=template&id=39c114cc&scoped=true"
import script from "./InputProductDetails.vue?vue&type=script&lang=js"
export * from "./InputProductDetails.vue?vue&type=script&lang=js"
import style0 from "./InputProductDetails.vue?vue&type=style&index=0&id=39c114cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c114cc",
  null
  
)

export default component.exports